module.exports = __webpack_public_path__ + "static/img/20171229.5c1a2a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20171229.jpg
// module id = zqIU
// module chunks = 100